<div class="nav-sidebar-container flex flex-row items-center">
    <a
    class="flex items-center nav-item button"
    [class.disabled]="disabled()"
    [routerLink]="disabled() ? null : item().pagePath"
    routerLinkActive="active-button"
    ariaCurrentWhenActive="page"
    (mouseenter)="!disabled() && isHovered.set(true)"
    (mouseleave)="!disabled() && isHovered.set(false)"
    #rla="routerLinkActive">
        @if (item().pagePath === '/notifications' && notificationsNbr() > 0) {
            <p-overlaybadge [value]="notificationsNbr()" severity="danger" badgeSize="small">
                <app-icon-svg 
                width="24" 
                height="24" 
                [iconName]="item().iconName" 
                [color]="!disabled() && (isHovered() || rla.isActive) 
                    ? '#242651'
                    : '#fafafa'"
                ></app-icon-svg>
            </p-overlaybadge>
        } @else {
            <app-icon-svg 
            width="24" 
            height="24" 
            [iconName]="item().iconName" 
            [color]="!disabled() && (isHovered() || rla.isActive) 
                ? '#242651'
                : '#fafafa'"
            ></app-icon-svg>
        }
        {{ item().name }}
    </a>
</div>
